(ns frontend.ui.page.lp-report-editor.step-8-archived.view
  (:require
   [common.localization :as loc]
   [frontend.ui.page.lp-report-editor.common.event :as common-event]
   [frontend.ui.page.lp-report-editor.common.modal.pdf-preview-modal :as pdf-preview-modal]
   [frontend.ui.page.lp-report-editor.common.view :as common-view :refer
    [continue-button footer preview-pdf-button]]
   [frontend.ui.page.lp-report-editor.event :as editor-event]
   [frontend.ui.page.lp-report-editor.step-8-archived.sub :as sub]
   [re-frame.core :as rf]
   [ui.components.button.view :as button]))

(defn step-footer
  [selected-report feeder?]
  [footer
   {:left-content
    [:<>
     [continue-button]
     [:div
      [pdf-preview-modal/view
       {:on-close #(rf/dispatch [::common-event/close-pdf-preview])
        :report   selected-report
        :feeder?  feeder?}]
      [preview-pdf-button
       {:on-click #(rf/dispatch [::common-event/open-pdf-preview selected-report feeder?])}]]
     (when-let [burned-pdfs (seq (:lp-report/burned-pdfs selected-report))]
       [:div
        [button/secondary-hollow
         {:on-click #(rf/dispatch [::editor-event/open-burned-pdf burned-pdfs])}
         (loc/tr :open-burned-pdf)]])]
    :right-content
    [:<>]}])

(defn archived-report
  []
  [common-view/report-viewer sub/report-tab-path step-footer])

(defn body
  []
  [archived-report])
